// React bindings over the shared EventSource manager. Keep the handler in a ref so a
// component can pass an inline closure without re-subscribing on every render.
import { useEffect, useRef, useState } from 'react';
import { onStatus, subscribe, liveStatus, type LiveStatus } from './liveEvents.ts';

export function useLiveEvent<T = unknown>(type: string, handler: (payload: T) => void): void {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => subscribe(type, (payload) => ref.current(payload as T)), [type]);
}

export function useLiveStatus(): LiveStatus {
  const [status, setStatus] = useState<LiveStatus>(liveStatus);
  useEffect(() => onStatus(setStatus), []);
  return status;
}
